import React from "react";
import classNames from "classnames";
import styles from "./LineIndicator.module.scss";

const cx = classNames.bind(styles);

export interface LineIndicatorProps extends React.ComponentPropsWithoutRef<"ol"> {
  currentIndex: number;
  numberOfImages: number;
}

export const LineIndicator = ({
  currentIndex,
  numberOfImages,
  className,
  ...props
}: LineIndicatorProps) => {
  const lineClassNames = cx(styles.lineIndicator, className);

  return (
    <ol
      data-testid="standard:gallery:line-indicator"
      className={lineClassNames}
      {...props}
    >
      {[...Array(numberOfImages)].map((_, idx) => (
        <li
          className={idx === currentIndex ? styles.current : undefined}
          key={idx}
        />
      ))}
    </ol>
  );
};
